import React from 'react'
import { IProps } from './index'
import EditorialWrapItem from './item'
import styles from './style-legacy.scss'
import classnames from 'classnames'
import { LegacyColorName, getColorTheme, LegacyColor } from 'marketing-site/src/library/utils'
import FiveEyesCondensedWoff from 'marketing-site/src/fonts/FiveEyesCondensed-Bold.woff'
import FiveEyesCondensedWoff2 from 'marketing-site/src/fonts/FiveEyesCondensed-Bold.woff2'
import { EditorialWrap as EditorialWrapDefault } from './component'
import { NewBrandingHoc } from '../../utils/NewBrandingHoc'

export function EditorialWrapLegacy({ sidebar, content, backgroundColor }: IProps) {
  const colorTheme = getColorTheme('legacy', backgroundColor)
  const wrapClasses = classnames('editorial-wrap__section', {
    [`editorial-wrap__section--${LegacyColorName[colorTheme.id as LegacyColor]}`]: backgroundColor,
  })
  return (
    <div className={wrapClasses}>
      <div className="editorial-wrap">
        <div className="editorial-wrap__sidebar">
          {sidebar.map((item, i) => item && <EditorialWrapItem key={i} {...item} />)}
        </div>
        <div className="editorial-wrap__content">
          {content.map((item, i) => item && <EditorialWrapItem key={i} {...item} />)}
        </div>
      </div>
      <style jsx>{styles}</style>
      <style jsx>{`
        @font-face {
          font-family: 'Five Eyes Condensed';
          font-display: swap;
          src: url(${FiveEyesCondensedWoff2}) format('woff2'),
            url(${FiveEyesCondensedWoff}) format('woff');
          font-weight: bold;
          font-style: normal;
        }

        .editorial-wrap__section {
          background-color: ${colorTheme.backgroundColor};
          color: ${colorTheme.textColor};
        }
      `}</style>
    </div>
  )
}

export const EditorialWrap = NewBrandingHoc(EditorialWrapLegacy, EditorialWrapDefault)
